import * as React from "react";
import { Box, BoxProps, CircularProgress, styled } from "@mui/material";

export interface PosterImageProps extends BoxProps {
  img: React.ImgHTMLAttributes<HTMLImageElement>;
  showLoader?: boolean;
}

const PosterImage: React.FC<PosterImageProps> = (props) => {
  const { img, showLoader = false, ...otherProps } = props;

  const [isLoading, setIsLoading] = React.useState(true);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
  };

  return (
    <StyledFigure component="figure" overflow="hidden" borderRadius="4px" {...otherProps}>
      {isLoading && showLoader && (
        <CircularProgress
          sx={{
            position: "absolute",
            left: "45%",
            padding: 1,
          }}
        />
      )}
      {img.src && (
        <img {...img} alt={img.alt || ""} loading="lazy" onLoad={handleImageLoad} onError={handleImageError} />
      )}
      {props.children && props.children}
    </StyledFigure>
  );
};

export default PosterImage;

const StyledFigure = styled(Box)(({ theme }) => ({
  minHeight: 40,
  img: {
    ...theme.helpers(theme).fullImage,
  },
}));
